var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFolderSimpleMinus = function SvgIconFolderSimpleMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 12.5a1 1 0 1 0 0 2h4.5a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 4.25A1.75 1.75 0 0 0 2 6v12.75a1.75 1.75 0 0 0 1.75 1.75h16.584A1.665 1.665 0 0 0 22 18.834V8.25a1.75 1.75 0 0 0-1.75-1.75h-7.914l-2.54-1.9-.002-.002A1.76 1.76 0 0 0 8.75 4.25H3.75M4 18.5V6.25h4.664l2.54 1.9.002.002a1.76 1.76 0 0 0 1.043.348H20v10z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFolderSimpleMinus;